<template>
  <div class="main">
    <van-image
      fit="cover"
      src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/35.jpg"
      class="banner"
    />
    <!-- 产品介绍 -->
    <Introduce :title='"中小学MR智慧教育解决方案"'
    :desc='"中小学MR智慧教育解决⽅案，摆脱了传统固定单⼀的展示形式，将课件内容以全息⽴体影像的方式呈现在空间中，师⽣可以通过多功能六⾃由度⼿柄与全息课件内容互动，同时实现多人交互，同步反馈，上课形式多样，体验更加丰富。"' 
    :descMobile='"中小学MR智慧教育解决⽅案，摆脱了传统固定单⼀的展示形式，将课件内容以全息⽴体影像的方式呈现在空间中，师⽣可以通过多功能六⾃由度⼿柄与全息课件内容互动，同时实现多人交互，同步反馈，上课形式多样，体验更加丰富。"' 
    :img='"https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/36.png"'></Introduce>
    <!-- 主要功能模块 -->
    <Module title="方案构成" :list='plan'></Module>
    <!-- 多端设备支持 -->
    <Constitute :title="'方案优势'" :constitute='constitute'></Constitute>
    <!-- 课件资源 -->
    <div class="tiny">
      <div class="title">课程内容</div>
      <div class="contentVessel">
        <div class="content">
          <div
              class="list"
              v-for="item of list"
              :key="item"
            >
              <div class="desc" v-for="itemSun of item" :key="itemSun">
                {{ itemSun }}
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Introduce from '@/component/introduce'
import Constitute from '@/component/constitute'
import Module from '@/component/module';
export default {
  components: {
    Introduce,
    Constitute,
    Module
  },
  data() {
    return {
    //   list: [1, 2, 3, 4],
      plan: [
        {
          title: '硬件体系',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/6.png',
          desc: '提供了MR眼镜、大屏投影系统、主机工作站等完善的硬件支持'
        },
        {
          title: '课程资源',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/7.png',
          desc: '包含9大学科资源，将不同的资源模型以“颗粒化”形式呈现'
        },
        {
          title: '教学平台',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/8.png',
          desc: '集中管理课程内容，对3D模型等资源进行集中增删改查等管理'
        }
      ],
      constitute: [
        {
          title: '立体直观',
          img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/1.png',
          desc: '摆脱传统单一展示形式，全息影像以动态、静态的方式在空间中呈现课件内容'
        },
        {
          title: '同步协同',
          img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/2.png',
          desc: '多人同步协同学习，身处何地皆可加入，无人数上限，信息同步反馈 '
        },
        {
          title: '化解难懂知识',
          img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/3.png',
          desc: '课件内容可以任意调整，师生可同一视角观察课件内容，分析教学中难点、痛点'
        },
        {
          title: '虚拟真实交互',
          img: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/4.png',
          desc: '虚拟内容与课堂知识实验模型等紧密结合，同时与虚拟环境和真实世界发生交互'
        }
      ],
      list: [
        [
          '认识太阳系',
          '人体骨骼',
          '蝴蝶的身体结构',
          '独特的昆虫身体'
        ],
        [
          '杠杆平衡的条件',
          '地形和地势',
          '血液循环系统',
          '曾侯乙编钟'
        ],
        [
          '输送血液的泵-心脏',
          '认识显微镜',
          '消化系统',
          '更多...'
        ]
      ]
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  .banner {
    width: 100%;
    height: 500px;
    display: block;
  }
  .details {
    margin: 0 auto;
    padding-top: 150px;
    width: 1200px;
    margin: 0 auto;
    .title {
      text-align: center;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 63px;
    }
    .content {
      // display: flex;
      margin-top: 50px;
      img:nth-child(1) {
        width: 740px;
        height: 290px;
        margin-right: 40px;
      }
      img:nth-child(2) {
        width: 420px;
        height: 290px;
      }
    }
    .desc {
      font-size: 24px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #80889a;
      line-height: 40px;
      margin-top: 50px;
    }
  }
  .tiny {
    width: 100%;
    width: 1200px;
    margin: 0 auto;
    padding-top: 113px;
    padding-bottom: 180px;
    .title {
      font-size: 42px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 63px;
      text-align: center;
    }
    .content {
        width: 100%;
        display: flex;
        margin-top: 22px;
        .list {
          width: 33.3%;
          min-height: 200px;
          border-right: 1px solid #7b7a7a;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          &:last-child {
            border-right: none;
          }
          .desc {
            color: #807c7c;
            font-size: 22px;
            line-height: 38px;
          }
        }
      }
  }
  .case {
    width: 100%;
    background: #fff;
    > div {
      width: 1200px;
      height: 691px;
      margin: 0 auto;
      padding-top: 1px;
      .title {
        font-size: 42px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.6);
        line-height: 1;
        text-align: center;
        margin-top: 48px;
      }
      .content {
        width: 100%;
        display: flex;
        height: 391px;
        margin-top: 49px;
        .hasImg {
          width: 33.3%;
          height: 100%;
          box-sizing: border-box;
          border-right: 1px solid #dadada;
          padding: 0 30px;
          &:nth-child(3) {
            border: none;
          }
          img {
            width: 100%;
            height: 200px;
          }
          .headline {
            margin-top: 40px;
            line-height: 1;
            font-size: 28px;
            font-weight: bold;
            color: #9fa1b4;
            display: block;
            &:nth-of-type(2) {
              margin-top: 10px;
            }
          }
          .desc {
            display: block;
            font-size: 18px;
            font-weight: 400;
            color: #9fa1b4;
            line-height: 24px;
            margin-top: 20px;
          }
        }
        .noImg {
          width: 33.3%;
          height: 100%;
          > div {
            width: 100%;
            padding: 15px;
            box-sizing: border-box;
            &:last-child {
              border-top: 1px solid #dadada;
            }
            .headline {
              font-size: 28px;
              font-weight: bold;
              color: #9fa1b4;
              line-height: 40px;
              min-height: 92px;
            }
            .desc {
              font-size: 18px;
              font-weight: 400;
              color: #9fa1b4;
              line-height: 24px;
              margin-top: 20px;
            }
          }
        }
      }
      .more {
        margin-top: 64px;
        display: flex;
        justify-content: center;
        span {
          font-size: 24px;
          color: #9fa1b4;
          line-height: 1;
        }
        img {
          width: 22px;
          height: 18px;
        }
      }
    }
  }
}
@media (max-width: 1000px) {
  .main{
    .banner {
      width: 100%;
      height: 348px;
      display: block;
    }
    .tiny{
      width: 100%;
      height: auto;
      padding-top: 1px;
      padding-bottom: 120px;
      .title{
        font-size: 44px;
        margin-top: 80px;
      }
      .contentVessel{
        width: 100%;
        overflow-x: auto;
      }
      .content{
          display: block;
          overflow: hidden;
          .list{
            width: 100%;
            position: relative;
            border: none;
            padding: 40px;
            .desc{
              font-size: 32px;
              color: #5E5E5E;
              letter-spacing: 0;
              text-align: center;
              line-height: 52px;
              font-weight: 400;
            }
            &::after{
              content: '';
              position: absolute;
              bottom: -2px;
              left: 50%;
              margin-left: -50px;
              width: 100px;
              height: 2px;
              background: #F8BA1D;
            }
          }
        }
    }
  }
}
</style>
